import * as types from "./types";

const mutations = {
    [types.LOADING_PERFORMANCE_RECORD](state, value) {
        state.loading = value;
    },
    [types.GET_PERFORMANCE_RECORD_LIST](state, performanceRecords) {
        state.performanceRecords = performanceRecords;
    },
    [types.Add_PERFORMANCE_RECORD](state, performanceRecord) {        
        state.performanceRecords.unshift(performanceRecord);
    },
    [types.Update_PERFORMANCE_RECORD](state, performanceRecord) {        
        const performanceRecorsIndex = state.performanceRecords.findIndex((x) => x.id === performanceRecord.id);
        state.performanceRecords[performanceRecorsIndex] = performanceRecord;        
    },
    [types.REMOVE_PERFORMANCE_RECORD](state, id) {        
        state.performanceRecords = state.performanceRecords.filter((x) => x.id !== id);        
    },
};

export default mutations;